module.exports = __webpack_public_path__ + "media/images/report_problem-24px-purple-62079d325888a60a405dc896c2e2423a.svg";